import { Typography } from "@reconvert/react-ui-component";
import React from "react";
import { useTranslation } from "react-i18next";
import useConditions from "../../../../hooks/useConditions";
import { useDirection } from "../../../../hooks/useDirection";

const ConditionOverview = () => {
  const { selectedCondition } = useConditions();
  const { t } = useTranslation();
  const { isRTL } = useDirection();

  return (
    <>
      <Typography sx={{ paddingInlineStart: 4 }} pt={4} variant="h5-medium" mb={2}>
        {t(selectedCondition?.name ?? "")}
      </Typography>
      <Typography sx={{ paddingInlineStart: 4 }} variant="body">
        {t("Click on a card to start working")}
      </Typography>
    </>
  );
};

export default React.memo(ConditionOverview);
